import React, { Component } from "react";
import { Link } from "react-router-dom";
class ServiceSlide extends Component {
  render() {
    return (
      <div className="row-services">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={81}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-carousel-box data-effect clearfix"
                data-gap={30}
                data-column={3}
                data-column2={2}
                data-column3={1}
                data-auto="true"
              >
                <div className="owl-carousel owl-theme">
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service1.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">PLYWOOD & MDF BOARDS</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Premium quality plywood in 3mm, 6mm, 9mm sizes, MDF
                            boards, and marine boards for all construction [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service2.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">BLOCK BOARDS & CHIP BOARDS</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            High-quality 18mm MDF plain, block boards in various
                            sizes,Particle boards (All types) and chip boards for superior strength [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service3.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">VENEER PLY & LAMINATES</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            MDF veneers in various wood finishes and decorative
                            laminates for premium furniture and interiors [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service4.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">PAINTS & FINISHES</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Premium paints from Seweco, wood finishes,
                            sandpaper, lipping materials, and Cona adhesives
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service5.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">TOOLS & FASTENERS</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Professional hammers, screwdrivers, pliers,
                            measuring tapes, and Valida self-tapping screws
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/service6.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">CEMENT & ADHESIVES</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Blue Triangle, Nguvi cement, Cona and Ponal contact
                            adhesives for all your bonding needs [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={15}
                data-mobile={15}
                data-smobile={15}
              />
              <div
                className="themesflat-carousel-box data-effect clearfix"
                data-gap={30}
                data-column={3}
                data-column2={2}
                data-column3={1}
                data-auto="true"
              >
                <div className="owl-carousel owl-theme">
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-7-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">MARBLE SHEETS & LAMINATES</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Beautiful marble sheets and MDF laminated boards in
                            various colors and designs for elegant finishes
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-8-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">SANDPAPER & LIPPING</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Various grades of sandpaper and edge lipping
                            materials for perfect wood finishing and edge
                            banding [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-9-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">VENEER PLY & MARINE BOARDS</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Premium veneer ply and water-resistant marine boards
                            for high-quality furniture and outdoor applications
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-10-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">SCREWS & NAILS</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Comprehensive range of screws, concrete nails, and
                            all types of fasteners for construction projects
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-11-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">BULK ORDERS & WHOLESALE</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            We offer competitive pricing for bulk orders and
                            wholesale supply for contractors and large projects
                            [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="themesflat-image-box style-2 clearfix">
                    <div className="image-box-item">
                      <div className="inner">
                        <div className="thumb data-effect-item">
                          <img
                            src="assets/img/imagebox/image-box-12-370x215.jpeg"
                            alt="altimage"
                          />
                          <div className="overlay-effect bg-color-accent" />
                        </div>
                        <div className="text-wrap">
                          <h5 className="heading">
                            <Link to="#">CONSULTATION SERVICES</Link>
                          </h5>
                          <p className="letter-spacing-01">
                            Expert advice on material selection, quantities, and
                            specifications for your construction or furniture
                            project [...]
                          </p>
                          <div className="elm-readmore">
                            <Link to="/service-detail">DETAILS</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={45}
                data-mobile={60}
                data-smobile={60}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceSlide;
